var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.$emit('click', $event)}}},[_vm._v("追加")])}
var staticRenderFns = []

export { render, staticRenderFns }